import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Input, message, Select, DatePicker } from 'antd';
import { graphql, compose } from 'react-apollo';
import validationRegex from '@eumentis-cloud/js-validation-regex';
import moment from 'moment';

import { constitutionsList, sectorsList, segmentsList, activitiesList } from '../utils/lists';

import NewRetainerClientMutation from '../graphql/mutations/newRetainerClientMutation.graphql';

const FormItem = Form.Item;
const { TextArea } = Input;
const { Option } = Select;

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 12 },
};

class NewRetainerClientForm extends Component {
  state = {
    submittingForm: false,
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({
      submittingForm: true,
    });

    const { form, mutate, history } = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        mutate({ variables: values })
          .then(() => {
            this.setState({
              submittingForm: false,
            });
            history.goBack();
            message.success('New client created!');
          })
          .catch((err1) => {
            this.setState({
              submittingForm: false,
            });
            console.log(err1);
            message.error(err1.message);
          });
      } else {
        this.setState({
          submittingForm: false,
        });
      }
    });
  };

  render() {
    const { submittingForm } = this.state;
    const { form } = this.props;
    const { getFieldDecorator } = form;
    return (
      <div className="contentBox">
        <h2>Add new client</h2>
        <Form layout="horizontal" onSubmit={this.handleSubmit}>
          <FormItem label="Company Name" hasFeedback {...formItemLayout}>
            {getFieldDecorator('name', {
              rules: [{ required: true, message: 'Field is required!' }],
            })(<Input disabled={submittingForm} />)}
          </FormItem>
          <FormItem label="Constitution" hasFeedback {...formItemLayout}>
            {getFieldDecorator('constitution', {
              rules: [{ required: true, message: 'Field is required!' }],
            })(
              <Select disabled={submittingForm} showSearch>
                {constitutionsList.map((entry) => (
                  <Option key={entry} value={entry}>
                    {entry}
                  </Option>
                ))}
              </Select>,
            )}
          </FormItem>
          <FormItem label="Sectors" {...formItemLayout}>
            {getFieldDecorator('sectors')(
              <Select disabled={submittingForm} mode="multiple">
                {sectorsList.map((entry) => (
                  <Option key={entry} value={entry}>
                    {entry}
                  </Option>
                ))}
              </Select>,
            )}
          </FormItem>
          <FormItem label="Activities" {...formItemLayout}>
            {getFieldDecorator('activities')(
              <Select disabled={submittingForm} mode="multiple">
                {activitiesList.map((entry) => (
                  <Option key={entry} value={entry}>
                    {entry}
                  </Option>
                ))}
              </Select>,
            )}
          </FormItem>
          <FormItem label="Segment" {...formItemLayout}>
            {getFieldDecorator('segment')(
              <Select disabled={submittingForm} showSearch>
                {segmentsList.map((entry) => (
                  <Option key={entry} value={entry}>
                    {entry}
                  </Option>
                ))}
              </Select>,
            )}
          </FormItem>
          <FormItem label="Address" {...formItemLayout}>
            {getFieldDecorator('streetAddress')(
              <TextArea autosize={{ minRows: 2, maxRows: 4 }} disabled={submittingForm} />,
            )}
          </FormItem>
          <FormItem label="City" {...formItemLayout}>
            {getFieldDecorator('city')(<Input disabled={submittingForm} />)}
          </FormItem>
          <FormItem label="State" {...formItemLayout}>
            {getFieldDecorator('state')(<Input disabled={submittingForm} />)}
          </FormItem>
          <FormItem label="Pincode" hasFeedback {...formItemLayout}>
            {getFieldDecorator('pincode', {
              rules: [{ pattern: validationRegex.pincode, message: 'Incorrect value' }],
            })(<Input disabled={submittingForm} />)}
          </FormItem>
          <FormItem label="Company Email" hasFeedback {...formItemLayout}>
            {getFieldDecorator('email', {
              rules: [{ type: 'email', message: 'Incorrect value' }],
            })(<Input disabled={submittingForm} />)}
          </FormItem>
          <FormItem label="Company Landline" hasFeedback {...formItemLayout}>
            {getFieldDecorator('landline', {
              rules: [{ pattern: validationRegex.landline, message: 'Incorrect value' }],
            })(<Input disabled={submittingForm} />)}
          </FormItem>
          <FormItem label="Company Website" {...formItemLayout}>
            {getFieldDecorator('website')(<Input disabled={submittingForm} />)}
          </FormItem>
          <h3>Primary Contact Person</h3>
          <FormItem label="Full Name" hasFeedback {...formItemLayout}>
            {getFieldDecorator('primaryContactName', {
              rules: [{ required: true, message: 'Field is required!' }],
            })(<Input required disabled={submittingForm} />)}
          </FormItem>
          <FormItem label="Mobile" hasFeedback {...formItemLayout}>
            {getFieldDecorator('primaryContactMobile', {
              rules: [
                { required: true, message: 'Field is required!' },
                { pattern: validationRegex.mobile, message: 'Incorrect value' },
              ],
            })(<Input required addonBefore="+91" disabled={submittingForm} />)}
          </FormItem>
          <FormItem label="Email" hasFeedback {...formItemLayout}>
            {getFieldDecorator('primaryContactEmail', {
              rules: [{ required: true, message: 'Field is required!' }, { type: 'email', message: 'Incorrect value' }],
            })(<Input required disabled={submittingForm} />)}
          </FormItem>
          <FormItem label="Designation" hasFeedback {...formItemLayout}>
            {getFieldDecorator('primaryContactDesignation', {
              rules: [{ required: true, message: 'Field is required!' }],
            })(<Input required disabled={submittingForm} />)}
          </FormItem>
          <h3>Additional Details</h3>
          <FormItem label="Retainer Start Date" hasFeedback {...formItemLayout}>
            {getFieldDecorator('startDate', {
              initialValue: moment(),
              rules: [{ required: true, message: 'Field is required!' }],
            })(<DatePicker disabled={submittingForm} format="Do MMM, YYYY" />)}
          </FormItem>

          <FormItem>
            <Button type="primary" htmlType="submit" loading={submittingForm}>
              Submit
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

NewRetainerClientForm.propTypes = {
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func,
    validateFieldsAndScroll: PropTypes.func,
    resetFields: PropTypes.func,
  }).isRequired,
  mutate: PropTypes.func.isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }).isRequired,
};

export default compose(
  graphql(NewRetainerClientMutation),
  Form.create(),
)(NewRetainerClientForm);



// WEBPACK FOOTER //
// ./src/forms/NewRetainerClientForm.jsx